import { Link } from "react-router-dom";
import { ArrowLeft, Cookie, Info, Settings, Shield } from "lucide-react";

const LOGO_URL = "/images/logo-full.png";

export default function CookiePolicy() {
  return (
    <div className="min-h-screen bg-slate-50">
      {/* Header */}
      <header className="bg-white border-b border-slate-200 sticky top-0 z-10">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/login" className="flex items-center gap-2 text-slate-600 hover:text-slate-900">
            <ArrowLeft className="w-4 h-4" />
            <span>Torna al login</span>
          </Link>
          <img src={LOGO_URL} alt="Affidya" className="h-8" />
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 py-8">
        <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-8">
          
          <div className="flex items-center gap-3 mb-6">
            <div className="p-3 bg-amber-100 rounded-lg">
              <Cookie className="w-6 h-6 text-amber-600" />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-slate-900">Cookie Policy</h1>
              <p className="text-slate-500">Informativa sull'uso dei cookie</p>
            </div>
          </div>

          <p className="text-sm text-slate-500 mb-8">Ultimo aggiornamento: Dicembre 2025</p>

          {/* Sezione 1 */}
          <section className="mb-8">
            <h2 className="text-lg font-semibold text-slate-900 mb-3 flex items-center gap-2">
              <Info className="w-5 h-5 text-amber-600" />
              1. Cosa sono i Cookie
            </h2>
            <p className="text-slate-700">
              I cookie sono piccoli file di testo che i siti web salvano sul tuo dispositivo (computer, tablet, smartphone) 
              durante la navigazione. Vengono utilizzati per migliorare l'esperienza di navigazione, 
              memorizzare le preferenze dell'utente e garantire il corretto funzionamento del sito.
            </p>
          </section>

          {/* Sezione 2 */}
          <section className="mb-8">
            <h2 className="text-lg font-semibold text-slate-900 mb-3 flex items-center gap-2">
              <Settings className="w-5 h-5 text-amber-600" />
              2. Cookie Utilizzati da Affidya
            </h2>
            
            <div className="bg-green-50 rounded-lg p-4 border border-green-200 mb-4">
              <p className="text-green-900 font-medium mb-2">Utilizzo Minimo di Cookie</p>
              <p className="text-green-800 text-sm">
                La piattaforma Affidya utilizza esclusivamente cookie <strong>tecnici e strettamente necessari</strong> 
                al funzionamento del servizio. Non utilizziamo cookie di profilazione o di terze parti per finalità pubblicitarie.
              </p>
            </div>

            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="bg-slate-100">
                    <th className="text-left p-3 font-medium">Nome Cookie</th>
                    <th className="text-left p-3 font-medium">Tipo</th>
                    <th className="text-left p-3 font-medium">Finalità</th>
                    <th className="text-left p-3 font-medium">Durata</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-200">
                  <tr>
                    <td className="p-3 font-mono text-xs">auth_token</td>
                    <td className="p-3"><span className="px-2 py-1 bg-green-100 text-green-800 rounded text-xs">Tecnico</span></td>
                    <td className="p-3">Autenticazione utente (JWT)</td>
                    <td className="p-3">30 minuti</td>
                  </tr>
                  <tr>
                    <td className="p-3 font-mono text-xs">refresh_token</td>
                    <td className="p-3"><span className="px-2 py-1 bg-green-100 text-green-800 rounded text-xs">Tecnico</span></td>
                    <td className="p-3">Rinnovo sessione</td>
                    <td className="p-3">7 giorni</td>
                  </tr>
                  <tr>
                    <td className="p-3 font-mono text-xs">user_preferences</td>
                    <td className="p-3"><span className="px-2 py-1 bg-blue-100 text-blue-800 rounded text-xs">Funzionale</span></td>
                    <td className="p-3">Preferenze interfaccia</td>
                    <td className="p-3">1 anno</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          {/* Sezione 3 */}
          <section className="mb-8">
            <h2 className="text-lg font-semibold text-slate-900 mb-3 flex items-center gap-2">
              <Shield className="w-5 h-5 text-amber-600" />
              3. Cookie di Terze Parti
            </h2>
            <div className="bg-slate-50 rounded-lg p-4">
              <p className="text-slate-700">
                <strong>Attualmente non utilizziamo cookie di terze parti.</strong>
              </p>
              <p className="text-slate-600 text-sm mt-2">
                Non sono presenti cookie di:
              </p>
              <ul className="text-slate-600 text-sm mt-2 space-y-1">
                <li>• Google Analytics o altri strumenti di analisi</li>
                <li>• Social network (Facebook, Twitter, LinkedIn)</li>
                <li>• Piattaforme pubblicitarie</li>
                <li>• Servizi di remarketing</li>
              </ul>
              <p className="text-slate-500 text-xs mt-3">
                In caso di futura integrazione di servizi di terze parti, questa policy sarà aggiornata 
                e verrà richiesto un nuovo consenso ove necessario.
              </p>
            </div>
          </section>

          {/* Sezione 4 */}
          <section className="mb-8">
            <h2 className="text-lg font-semibold text-slate-900 mb-3">4. Gestione dei Cookie</h2>
            <p className="text-slate-700 mb-3">
              Poiché utilizziamo solo cookie tecnici strettamente necessari, non è richiesto il consenso preventivo 
              ai sensi dell'Art. 122 del Codice Privacy e delle Linee Guida del Garante.
            </p>
            <p className="text-slate-700 mb-3">
              Puoi comunque gestire o disabilitare i cookie attraverso le impostazioni del tuo browser. 
              Tieni presente che disabilitando i cookie tecnici, alcune funzionalità della piattaforma 
              potrebbero non funzionare correttamente.
            </p>
            
            <div className="bg-slate-50 rounded-lg p-4">
              <p className="font-medium text-slate-900 mb-2">Come disabilitare i cookie nei browser più comuni:</p>
              <ul className="text-slate-600 text-sm space-y-1">
                <li>• <strong>Chrome:</strong> Impostazioni → Privacy e sicurezza → Cookie</li>
                <li>• <strong>Firefox:</strong> Opzioni → Privacy e sicurezza → Cookie</li>
                <li>• <strong>Safari:</strong> Preferenze → Privacy → Cookie</li>
                <li>• <strong>Edge:</strong> Impostazioni → Cookie e autorizzazioni sito</li>
              </ul>
            </div>
          </section>

          {/* Sezione 5 */}
          <section className="mb-8">
            <h2 className="text-lg font-semibold text-slate-900 mb-3">5. Base Giuridica</h2>
            <p className="text-slate-700">
              I cookie tecnici sono installati sulla base del <strong>legittimo interesse</strong> del Titolare 
              (Art. 6.1.f GDPR) a garantire il corretto funzionamento della piattaforma e la sicurezza 
              delle sessioni utente.
            </p>
          </section>

          {/* Sezione 6 */}
          <section>
            <h2 className="text-lg font-semibold text-slate-900 mb-3">6. Contatti</h2>
            <p className="text-slate-700">
              Per qualsiasi domanda relativa all'uso dei cookie, puoi contattarci:
            </p>
            <div className="bg-blue-50 rounded-lg p-4 mt-3">
              <p className="text-blue-900">
                <strong>Email:</strong> privacy@affidya.it
              </p>
            </div>
          </section>

        </div>

        {/* Footer */}
        <div className="text-center mt-8 text-slate-500 text-sm">
          <p>© {new Date().getFullYear()} R&CO. GROUP S.r.l. - Tutti i diritti riservati</p>
          <div className="flex justify-center gap-4 mt-2">
            <Link to="/privacy" className="hover:text-slate-700">Privacy Policy</Link>
            <Link to="/cookies" className="hover:text-slate-700">Cookie Policy</Link>
            <Link to="/terms" className="hover:text-slate-700">Termini di Servizio</Link>
          </div>
        </div>
      </main>
    </div>
  );
}
